import { Check, Search, X } from 'lucide-react';
import { useEffect, useState } from 'react';
import api from '../../../config/axios-conf';
import styles from '../../../assets/scss/pages/CreateOrder.module.scss';
import useCartStore from '../../../stores/cartStore';

// Port từ app: screens/employee/SessionPerformerPickerModal.js (chọn NV thực hiện 1 buổi).
// UI/UX bám theo modal chọn NV của dịch vụ/combo; logic giữ nguyên (single-select theo buổi).

const AVATAR_COLORS = ['#0098F6', '#22C55E', '#F59E0B', '#EF4444', '#8B5CF6', '#EC4899', '#14B8A6', '#F97316'];

function getAvatarColor(name) {
    let h = 0;
    for (let i = 0; i < (name || '').length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
    return AVATAR_COLORS[Math.abs(h) % AVATAR_COLORS.length];
}

const normalize = (s) =>
    (s || '')
        .toString()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/đ/g, 'd');

export default function SessionPerformerPickerModal({ open, onClose, customerId, uid, sessionIdx }) {
    const item = useCartStore((s) =>
        (s.packageSessionCartByCustomer[customerId] || []).find((it) => it._uid === uid),
    );
    const setSessionPerformer = useCartStore((s) => s.setSessionPerformer);

    const [employees, setEmployees] = useState([]);
    const [search, setSearch] = useState('');

    useEffect(() => {
        if (!open) return;
        let alive = true;
        setSearch('');
        api.get('/employees/supportEmployeeAll')
            .then((res) => {
                if (alive) setEmployees(res?.data?.employees || []);
            })
            .catch(() => {
                if (alive) setEmployees([]);
            });
        return () => {
            alive = false;
        };
    }, [open]);

    if (!open || !item || sessionIdx == null) return null;

    const currentPerformerId = (item.performers || [])[sessionIdx] ?? null;

    const filtered = employees
        .filter((emp) => emp.user?.role !== 'checkin')
        .filter((emp) => (!search.trim() ? true : normalize(emp.name).includes(normalize(search))));

    const handleSelect = (emp) => {
        setSessionPerformer(customerId, uid, sessionIdx, emp.id);
        onClose();
    };

    return (
        <div className={styles.sideModalOverlay} onClick={onClose}>
            <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
                <div className={styles.modalHeader}>
                    <div>
                        <h3 className={styles.modalTitle}>Chọn NV thực hiện</h3>
                        <div style={{ fontSize: 13, color: '#6B7280', marginTop: 2 }}>
                            {item.packageName} · Buổi #{sessionIdx + 1}/{item.sessionCount}
                        </div>
                    </div>
                    <button className={styles.modalClose} onClick={onClose}>
                        <X size={18} />
                    </button>
                </div>

                <div className={styles.modalSearch}>
                    <Search size={16} />
                    <input
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder="Tìm nhân viên..."
                        autoFocus
                    />
                </div>

                <div className={styles.modalList}>
                    {filtered.length === 0 ? (
                        <div style={{ textAlign: 'center', padding: 24, color: '#94A3B8', fontSize: 13 }}>
                            {employees.length === 0 ? 'Không tải được danh sách NV' : 'Không tìm thấy'}
                        </div>
                    ) : (
                        filtered.map((emp) => {
                            const active = currentPerformerId === emp.id;
                            return (
                                <div
                                    key={emp.id}
                                    className={`${styles.modalItem}${active ? ` ${styles.modalItemActive}` : ''}`}
                                    onClick={() => handleSelect(emp)}
                                >
                                    <div
                                        className={styles.customerAvatar}
                                        style={{
                                            background: getAvatarColor(emp.name),
                                            width: 38,
                                            height: 38,
                                            fontSize: 14,
                                        }}
                                    >
                                        {(emp.name || '?')[0].toUpperCase()}
                                    </div>
                                    <div className={styles.modalItemInfo}>
                                        <div className={styles.modalItemName}>{emp.name}</div>
                                        {emp.position && (
                                            <div className={styles.modalItemPhone}>{emp.position}</div>
                                        )}
                                    </div>
                                    {active && (
                                        <div className={styles.modalItemCheck}>
                                            <Check size={13} />
                                        </div>
                                    )}
                                </div>
                            );
                        })
                    )}
                </div>
            </div>
        </div>
    );
}
